import { create } from "zustand";

export interface InterviewFormData {
  // Basic fields
  prompt: string;
  useDetailedForm?: boolean;

  // Job Information
  companyName?: string;
  jobTitle: string;
  department?: string;
  customDepartment?: string;
  employmentType?: string;
  experienceLevel: string;
  location?: string;

  // Additional Information
  keySkills?: string;
  salaryRange?: string;
  benefits?: string;

  // Files
  selectedFiles: Array<{
    name: string;
    size?: number;
    type?: string;
    isKnowledgeFile?: boolean;
    database?: string;
  }>;
}

interface InterviewFormStore {
  formData: InterviewFormData;
  updateField: <K extends keyof InterviewFormData>(
    field: K,
    value: InterviewFormData[K]
  ) => void;
  updateFormData: (data: Partial<InterviewFormData>) => void;
  resetForm: () => void;
  isFormValid: () => boolean;
  getInputPrompt: () => string;
}

const initialFormData: InterviewFormData = {
  prompt: "",
  useDetailedForm: true,
  jobTitle: "",
  experienceLevel: "",
  selectedFiles: [],
};

export const useInterviewFormStore = create<InterviewFormStore>((set, get) => ({
  formData: initialFormData,

  updateField: (field, value) =>
    set((state) => ({
      formData: { ...state.formData, [field]: value },
    })),

  updateFormData: (data) =>
    set((state) => ({
      formData: { ...state.formData, ...data },
    })),

  resetForm: () =>
    set({
      formData: initialFormData,
    }),

  isFormValid: () => {
    const { formData } = get();
    return !!(formData.jobTitle.trim() && formData.experienceLevel.trim());
  },

  getInputPrompt: () => {
    const { formData } = get();
    // if (formData.useDetailedForm) {
    const metaData = {
      jobTitle: formData.jobTitle,
      experienceLevel: formData.experienceLevel,
      prompt: formData.prompt,
    };
    return JSON.stringify(metaData);
    // }
    // return formData.prompt;
  },
}));
